module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/stripe-dashboard/stripe-dashboard.component.sass
// module id = ./src/app/demo/stripe-dashboard/stripe-dashboard.component.sass
// module chunks = main